import React, { useState } from 'react'
import {
  Compass,
  Search,
  ShieldAlert,
  PenTool,
  Palette,
  Video,
  FileText,
  Target,
  BarChart3,
  Flame,
  Sparkles,
  Terminal,
  Cpu,
  ChevronRight,
  X,
} from 'lucide-react'
const AgentDreamTeam = () => {
  const [selectedGroup, setSelectedGroup] = useState('all')
  const [activeAgentModal, setActiveAgentModal] = useState(null)
  const agents = [
    // Grupo A: Dirección y Estrategia
    {
      id: 'director-mkt',
      name: 'Director de Marketing IA',
      codename: 'orchestrator-chief',
      group: 'A',
      groupName: 'Direcci\xF3n y Estrategia',
      role: 'Orquestaci\xF3n & Gobernanza',
      description:
        'Dise\xF1a la hoja de ruta general, coordina los entregables entre agentes y valida el cumplimiento de KPIs por cliente.',
      icon: Compass,
      skills: [
        'Roadmap trimestral',
        'Asignaci\xF3n de tareas',
        'Control de calidad',
        'Supervisi\xF3n de KPIs',
      ],
      tools: [
        'Omni-Agent Hub',
        'Jira / ClickUp API',
        'Slack / Discord Webhooks',
      ],
      sampleOutput:
        'Plan de choque validado para Cliente #3: 4 creatividades nuevas asignadas a Isaura, 2 copies directos a Valentina, y reasignaci\xF3n de presupuesto por Alexa.',
    },
    {
      id: 'investigador-mercado',
      name: 'Estratega e Investigador de Mercado',
      codename: 'market-intel-v4',
      group: 'A',
      groupName: 'Direcci\xF3n y Estrategia',
      role: 'Inteligencia Competitiva',
      description:
        'Analiza competidores, detecta oportunidades de posicionamiento y extrae insights de audiencias objetivo.',
      icon: Search,
      skills: [
        'Benchmarking continuo',
        'An\xE1lisis de gaps',
        'Buyer persona din\xE1mico',
        'Auditor\xEDa de ofertas',
      ],
      tools: ['Meta Ad Library Scraper', 'Google Trends API', 'Semrush API'],
      sampleOutput:
        'Reporte de nicho listo: los 3 principales competidores han saturado el gancho de precio. Oportunidad abierta en mensaje de conveniencia e inmediatez.',
    },
    {
      id: 'auditor-campanas',
      name: 'Auditor de Cuentas y Campa\xF1as',
      codename: 'budget-leak-guard',
      group: 'A',
      groupName: 'Direcci\xF3n y Estrategia',
      role: 'Detecci\xF3n de Ineficiencias',
      description:
        'Examina las cuentas publicitarias y estructuras de contenido para identificar fugas de presupuesto.',
      icon: ShieldAlert,
      skills: [
        'Control de fuga de gasto',
        'Puntuaci\xF3n de salud de cuenta',
        'Solapamiento de audiencias',
        'Verificaci\xF3n de p\xEDxeles',
      ],
      tools: ['Meta Graph API', 'Google Ads API', 'CAPI Health Check'],
      sampleOutput:
        'Alerta resuelta: 14% de gasto en Meta compet\xEDa internamente por la misma audiencia en dos adsets. Regla correctiva aplicada en tiempo real.',
    },
    // Grupo B: Creatividad y Producción
    {
      id: 'valentina-copy',
      name: 'Valentina (Copywriter)',
      codename: 'valentina-copy',
      group: 'B',
      groupName: 'Creatividad y Producci\xF3n',
      role: 'Copywriting de Conversi\xF3n Directa',
      description:
        'Redacta textos persuasivos para anuncios, p\xE1ginas de venta, secuencias de email y redes sociales.',
      icon: PenTool,
      skills: [
        'Direct Response Copy',
        'Emails de alta apertura',
        'Frameworks AIDA/PAS',
        'Hooks de TikTok',
      ],
      tools: ['Klaviyo API', 'Meta Ads Manager', 'WordStream NLP Engine'],
      sampleOutput:
        '3 ganchos magn\xE9ticos redactados para campa\xF1a de captaci\xF3n. Tasa de CTR prevista: > 3.4% con enfoque en pain point de sobrecostes.',
    },
    {
      id: 'isaura-visual',
      name: 'Isaura (Dise\xF1adora Visual)',
      codename: 'isaura-creative-lab',
      group: 'B',
      groupName: 'Creatividad y Producci\xF3n',
      role: 'Dise\xF1o Publicitario & Branding',
      description:
        'Genera l\xEDneas gr\xE1ficas, creatividades publicitarias y recursos visuales alineados a las gu\xEDas de marca.',
      icon: Palette,
      skills: [
        'Banners publicitarios',
        'Carousels para LinkedIn/IG',
        'Adaptaci\xF3n multiformato',
        'Control crom\xE1tico estricto',
      ],
      tools: ['Figma API', 'SVG Engine', 'Hutrit Asset Composer'],
      sampleOutput:
        'Pack de 8 piezas para Story/Feed exportadas en resoluci\xF3n retina, siguiendo la tipograf\xEDa oficial y contraste accesible WCAG AA.',
    },
    {
      id: 'luis-miguel-video',
      name: 'Luis (Editor) & Miguel (Guionista)',
      codename: 'media-shortform-duo',
      group: 'B',
      groupName: 'Creatividad y Producci\xF3n',
      role: 'V\xEDdeo Corto & Storytelling',
      description:
        'Producen guiones para formato corto (Reels/TikTok/Shorts) y estructuran la edici\xF3n de contenidos.',
      icon: Video,
      skills: [
        'Guiones con retenci\xF3n 3s',
        'Estructura de B-roll',
        'Subtitulado din\xE1mico',
        'Call To Action sonoro',
      ],
      tools: [
        'CapCut Cloud API',
        'ElevenLabs Audio',
        'Shotstack Video Renderer',
      ],
      sampleOutput:
        'Gui\xF3n de 45 segundos estructurado con gancho visual inicial, ritmo de corte cada 1.8 segundos y guionizado de locuci\xF3n persuasiva.',
    },
    {
      id: 'generador-blogs',
      name: 'Generador de Blogs',
      codename: 'seo-content-engine',
      group: 'B',
      groupName: 'Creatividad y Producci\xF3n',
      role: 'Redacci\xF3n SEO Editorial',
      description:
        'Redacta art\xEDculos optimizados para SEO con investigaci\xF3n profunda y estructura editorial profesional.',
      icon: FileText,
      skills: [
        'Cluster sem\xE1ntico',
        'Estructura H2/H3',
        'Enlazado interno sugerido',
        'Meta descripciones CTR',
      ],
      tools: [
        'WordPress REST API',
        'Google Search Console',
        'Ahrefs Content Index',
      ],
      sampleOutput:
        'Art\xEDculo de 1.800 palabras estructurado con intenci\xF3n de b\xFAsqueda transaccional. Densidad de palabras clave calibrada sin canibalizaci\xF3n.',
    },
    // Grupo C: Datos y Rendimiento (Performance)
    {
      id: 'alexa-paid-media',
      name: 'Alexa (Paid Media) & Optimizador de Ads',
      codename: 'alexa-paid-media',
      group: 'C',
      groupName: 'Datos y Rendimiento',
      role: 'Media Buying Aut\xF3nomo',
      description:
        'Ajusta pujas, audiencias y creatividades en tiempo real para maximizar el ROAS en Meta, Google y TikTok Ads.',
      icon: Target,
      skills: [
        'Puja algor\xEDtmica',
        'Exclusi\xF3n de audiencias quemadas',
        'Testing multivariable',
        'Defensa de ROAS m\xEDnimo',
      ],
      tools: [
        'Meta Ads API',
        'Google Ads Smart Bidding',
        'TikTok Marketing API',
      ],
      sampleOutput:
        'Reasignados 250 \u20AC diarios del AdSet #2 (ROAS 1.9x) al AdSet #4 (ROAS 4.6x). Descenso de CPA global del 24% registrado en 48 horas.',
    },
    {
      id: 'geralis-analista',
      name: 'Geralis (Analista de Datos)',
      codename: 'geralis-analista',
      group: 'C',
      groupName: 'Datos y Rendimiento',
      role: 'Anal\xEDtica Unificada & Reporting',
      description:
        'Consolida m\xE9tricas de m\xFAltiples fuentes y genera informes autom\xE1ticos de rendimiento.',
      icon: BarChart3,
      skills: [
        'Dashboards en vivo',
        'Atribuci\xF3n multitoque',
        'Reportes de cliente PDF/Web',
        'Detecci\xF3n de anomal\xEDas',
      ],
      tools: [
        'Google Analytics 4',
        'Looker Studio Sync',
        'Triple Whale / Hyros Hook',
      ],
      sampleOutput:
        'Informe ejecutivo mensual compilado para los 10 clientes: m\xE9tricas de retorno desglosadas, con resumen en lenguaje claro para el cliente final.',
    },
    {
      id: 'analista-tendencias',
      name: 'Analista de Tendencias',
      codename: 'trend-radar-ai',
      group: 'C',
      groupName: 'Datos y Rendimiento',
      role: 'Detecci\xF3n Previa de Tendencias',
      description:
        'Monitoriza patrones emergentes en la industria para proponer ideas virales y \xE1ngulos de venta anticipados.',
      icon: Flame,
      skills: [
        'Social listening',
        'Patrones de audio viral',
        'Evoluci\xF3n de intenciones de compra',
        '\xC1ngulos estacionales',
      ],
      tools: [
        'TikTok Creative Center',
        'X Trending Stream',
        'Reddit Sentiment Analyser',
      ],
      sampleOutput:
        '3 tendencias de audio en TikTok identificadas en fase temprana de adopci\xF3n. Recomendado grabar contenidos esta semana antes de saturaci\xF3n.',
    },
  ]
  const filteredAgents =
    selectedGroup === 'all'
      ? agents
      : agents.filter((a) => a.group === selectedGroup)
  return (
    <section
      id="agentes"
      className="py-24 relative bg-[#012622] bg-tactical-grid border-t border-[#00FF9D]/15"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-[#05332E] border border-[#00FF9D]/30 text-xs font-mono text-[#00FF9D] uppercase tracking-wider mb-4">
            <Cpu className="w-3.5 h-3.5" />
            Especialización Vertical en Marketing
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-tight mb-4">
            El &quot;Dream Team&quot; de{' '}
            <span className="text-[#00FF9D]">Agentes de IA</span>
          </h2>
          <p className="text-base sm:text-lg text-[#CBD5E1]">
            No son chatbots genéricos. Son agentes con arquitectura modular,
            memoria compartida y conexión directa a tus herramientas de trabajo.
          </p>

          {/* Group Filter Buttons */}
          <div className="flex flex-wrap items-center justify-center gap-2 mt-8">
            <button
              onClick={() => setSelectedGroup('all')}
              className={`px-4 py-2 rounded-full text-xs sm:text-sm font-medium transition-all ${
                selectedGroup === 'all'
                  ? 'bg-[#00FF9D] text-[#012622] font-bold shadow-[0_0_15px_rgba(0,255,157,0.35)]'
                  : 'bg-[#05332E]/80 text-[#CBD5E1] hover:text-white border border-[#00FF9D]/15'
              }`}
            >
              Todos los Agentes (10)
            </button>
            <button
              onClick={() => setSelectedGroup('A')}
              className={`px-4 py-2 rounded-full text-xs sm:text-sm font-medium transition-all ${
                selectedGroup === 'A'
                  ? 'bg-[#00FF9D] text-[#012622] font-bold shadow-[0_0_15px_rgba(0,255,157,0.35)]'
                  : 'bg-[#05332E]/80 text-[#CBD5E1] hover:text-white border border-[#00FF9D]/15'
              }`}
            >
              Grupo A: Dirección y Estrategia (3)
            </button>
            <button
              onClick={() => setSelectedGroup('B')}
              className={`px-4 py-2 rounded-full text-xs sm:text-sm font-medium transition-all ${
                selectedGroup === 'B'
                  ? 'bg-[#00FF9D] text-[#012622] font-bold shadow-[0_0_15px_rgba(0,255,157,0.35)]'
                  : 'bg-[#05332E]/80 text-[#CBD5E1] hover:text-white border border-[#00FF9D]/15'
              }`}
            >
              Grupo B: Creatividad y Producción (4)
            </button>
            <button
              onClick={() => setSelectedGroup('C')}
              className={`px-4 py-2 rounded-full text-xs sm:text-sm font-medium transition-all ${
                selectedGroup === 'C'
                  ? 'bg-[#00FF9D] text-[#012622] font-bold shadow-[0_0_15px_rgba(0,255,157,0.35)]'
                  : 'bg-[#05332E]/80 text-[#CBD5E1] hover:text-white border border-[#00FF9D]/15'
              }`}
            >
              Grupo C: Datos y Rendimiento (3)
            </button>
          </div>
        </div>

        {/* 3-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredAgents.map((agent) => {
            const Icon = agent.icon
            return (
              <div
                key={agent.id}
                onClick={() => setActiveAgentModal(agent)}
                className="group rounded-2xl bg-[#05332E]/70 hover:bg-[#05332E] border border-[#00FF9D]/20 hover:border-[#00FF9D]/60 p-6 transition-all duration-300 shadow-[0_10px_30px_rgba(0,0,0,0.4)] hover:shadow-[0_10px_35px_rgba(0,255,157,0.15)] hover:-translate-y-1 flex flex-col justify-between cursor-pointer relative overflow-hidden"
              >
                {/* Background ambient light */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-[#00FF9D]/5 rounded-full blur-2xl group-hover:bg-[#00FF9D]/15 transition-all" />

                <div>
                  {/* Top card bar */}
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-12 h-12 rounded-xl bg-[#012622] border border-[#00FF9D]/30 flex items-center justify-center text-[#00FF9D] group-hover:scale-110 transition-transform shadow-inner">
                      <Icon className="w-6 h-6" />
                    </div>
                    <div className="flex flex-col items-end">
                      <span className="text-[10px] font-mono px-2 py-0.5 rounded-full bg-[#012622] text-[#00FF9D] border border-[#00FF9D]/20">
                        {agent.groupName}
                      </span>
                      <span className="text-[10px] text-[#CBD5E1]/50 font-mono mt-0.5">
                        {agent.codename}
                      </span>
                    </div>
                  </div>

                  {/* Agent Name & Role */}
                  <h3 className="text-lg font-bold text-white mb-1 group-hover:text-[#00FF9D] transition-colors flex items-center gap-1.5">
                    <span>{agent.name}</span>
                  </h3>
                  <div className="text-xs font-mono text-[#00FF9D] mb-3">
                    {agent.role}
                  </div>

                  {/* Description */}
                  <p className="text-sm text-[#CBD5E1] leading-relaxed mb-4">
                    {agent.description}
                  </p>

                  {/* Skills tags */}
                  <div className="flex flex-wrap gap-1.5 mb-4">
                    {agent.skills.slice(0, 3).map((skill, sIdx) => (
                      <span
                        key={sIdx}
                        className="text-[11px] font-mono px-2 py-0.5 rounded bg-[#012622]/80 text-[#CBD5E1] border border-white/5"
                      >
                        {skill}
                      </span>
                    ))}
                    {agent.skills.length > 3 && (
                      <span className="text-[11px] font-mono px-1.5 py-0.5 rounded bg-[#012622] text-[#00FF9D]">
                        +{agent.skills.length - 3}
                      </span>
                    )}
                  </div>
                </div>

                {/* Card footer CTA */}
                <div className="pt-3 border-t border-[#0A3F39] flex items-center justify-between text-xs font-medium text-[#00FF9D] group-hover:text-white transition-colors">
                  <span className="flex items-center gap-1.5">
                    <span className="w-2 h-2 rounded-full bg-[#00FF9D] animate-pulse" />
                    Listo para asignar
                  </span>
                  <span className="inline-flex items-center gap-1 font-mono text-[11px]">
                    Ver ficha técnica
                    <ChevronRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      {/* Detail Modal for Agent */}
      {activeAgentModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-md animate-in fade-in duration-200">
          <div className="bg-[#031E1B] border border-[#00FF9D]/40 rounded-2xl max-w-xl w-full p-6 sm:p-8 shadow-[0_0_50px_rgba(0,255,157,0.25)] relative">
            <button
              onClick={() => setActiveAgentModal(null)}
              className="absolute top-4 right-4 p-2 rounded-lg bg-[#05332E] text-[#CBD5E1] hover:text-white border border-[#00FF9D]/20 cursor-pointer"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="flex items-center gap-4 mb-4">
              <div className="w-14 h-14 rounded-2xl bg-[#05332E] border border-[#00FF9D]/40 flex items-center justify-center text-[#00FF9D]">
                {React.createElement(activeAgentModal.icon, {
                  className: 'w-7 h-7',
                })}
              </div>
              <div>
                <span className="text-xs font-mono text-[#00FF9D] px-2 py-0.5 rounded bg-[#012622] border border-[#00FF9D]/30">
                  {activeAgentModal.groupName}
                </span>
                <h3 className="text-2xl font-bold text-white mt-1">
                  {activeAgentModal.name}
                </h3>
                <p className="text-xs text-[#CBD5E1]/70 font-mono">
                  {activeAgentModal.role} • {activeAgentModal.codename}
                </p>
              </div>
            </div>

            <p className="text-sm text-[#CBD5E1] mb-6 leading-relaxed">
              {activeAgentModal.description}
            </p>

            <div className="space-y-4">
              {/* Skills */}
              <div>
                <div className="text-xs font-mono text-white font-bold uppercase mb-2 flex items-center gap-1.5">
                  <Sparkles className="w-3.5 h-3.5 text-[#00FF9D]" />
                  Habilidades Nucleares:
                </div>
                <div className="flex flex-wrap gap-2">
                  {activeAgentModal.skills.map((skill, i) => (
                    <span
                      key={i}
                      className="text-xs px-2.5 py-1 rounded-md bg-[#05332E] text-white border border-[#00FF9D]/20"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              {/* Tools */}
              <div>
                <div className="text-xs font-mono text-white font-bold uppercase mb-2 flex items-center gap-1.5">
                  <Terminal className="w-3.5 h-3.5 text-[#00FF9D]" />
                  Conexiones de API & Herramientas:
                </div>
                <div className="flex flex-wrap gap-2">
                  {activeAgentModal.tools.map((tool, i) => (
                    <span
                      key={i}
                      className="text-xs px-2.5 py-1 rounded-md bg-[#012622] text-[#00FF9D] border border-[#00FF9D]/30 font-mono"
                    >
                      {tool}
                    </span>
                  ))}
                </div>
              </div>

              {/* Live Output Preview */}
              <div className="bg-[#011E1B] p-3.5 rounded-xl border border-[#00FF9D]/25 font-mono text-xs">
                <div className="text-[10px] text-[#00FF9D] uppercase tracking-wider mb-1 flex items-center gap-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#00FF9D]" />
                  Muestra de Ejecución Real:
                </div>
                <p className="text-[#CBD5E1] italic">
                  &quot;{activeAgentModal.sampleOutput}&quot;
                </p>
              </div>
            </div>

            <div className="mt-6 pt-4 border-t border-[#05332E] flex justify-end">
              <button
                onClick={() => {
                  setActiveAgentModal(null)
                  const form = document.getElementById('demo-form')
                  if (form) form.scrollIntoView({ behavior: 'smooth' })
                }}
                className="px-5 py-2.5 rounded-full bg-[#00FF9D] text-[#012622] font-bold text-xs sm:text-sm hover:bg-[#00E676] transition-colors cursor-pointer"
              >
                Solicitar Demostración de este Agente →
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  )
}
export { AgentDreamTeam }
